var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "un-authorized-layout row mx-0" },
    [
      _vm.isSignup && _vm.isYektanetPlt
        ? [
            _c(
              "div",
              { staticClass: "col-12 col-md-6 col-xl-5" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-none d-md-block col-md-6 col-xl-7 h-100",
                staticStyle: { "background-color": "#f5f5f5" }
              },
              [
                ![
                  "yektanet-rubika-adv",
                  "yektanet-sheypoor-adv",
                  "yektanet-retail-basalam-adv"
                ].includes(_vm.getParam("account_custom_type"))
                  ? _c("NewDesktopServicePromotion")
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm.isSignup && _vm.isLeadPlt
        ? [
            _c("div", { staticClass: "yn-logo" }, [
              _c("img", { attrs: { src: _vm.leadLogo } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-lg-none w-100 px-4 pb-4" }, [
              _c("h1", { staticClass: "page-title text-right" }, [
                _vm._v("ثبت‌نام")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "already-have-account" }, [
                _c("span", { staticStyle: { color: "#444" } }, [
                  _vm._v("قبلا ثبت‌نام کرده‌اید؟")
                ]),
                _vm._v(" "),
                _c("a", { attrs: { href: _vm.loginUrl } }, [
                  _vm._v(" ورود به حساب کاربری ")
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-lg-none col-12",
                staticStyle: { "background-color": "#fafafa" }
              },
              [_c("LeadMobileServicePromotion")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-lg-5" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-none d-lg-block col-lg-7 h-100",
                staticStyle: { "background-color": "#f5f5f5" }
              },
              [_c("LeadDesktopServicePromotion")],
              1
            )
          ]
        : [
            ![
              "yektanet-rubika-adv",
              "yektanet-sheypoor-adv",
              "yektanet-retail-basalam-adv"
            ].includes(_vm.getParam("account_custom_type"))
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-none d-md-block col-md-5 col-xl-4 border-start overflow-hidden",
                    staticStyle: { "background-color": "#f5f5f5" }
                  },
                  [
                    _c("desktop-service-promotion", {
                      attrs: { "utm-campaign": _vm.utmCampaign }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-7 col-xl-8 d-flex flex-column pr-xl-big py-5 py-md-0 position-relative"
              },
              [
                ![
                  "yektanet-rubika-adv",
                  "yektanet-sheypoor-adv",
                  "yektanet-retail-basalam-adv"
                ].includes(_vm.getParam("account_custom_type"))
                  ? _c("mobile-service-promotion", {
                      attrs: { "utm-campaign": _vm.utmCampaign }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("default"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mb-auto mx-auto w-100",
                    style: { maxWidth: _vm.maxWidth }
                  },
                  [
                    _c("account-support", {
                      attrs: {
                        email: _vm.email,
                        "utm-campaign": _vm.utmCampaign
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ],
      _vm._v(" "),
      _c("server-notifications")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }